/* eslint-disable camelcase */
import Alert from 'react-s-alert';
import download from 'downloadjs';

import { ServerIp } from '../constants/env';

export const getAllElementsFilter = (props) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  let filter = '?';
  props.street.forEach((item) => {
    filter += `street[]=${item}&`;
  })
  props.location.forEach((item) => {
    filter += `location[]=${item}&`;
  })

  fetch(`${ServerIp}api/v2/elements/get_positions${filter}`, {
    method: 'GET',
    headers: {
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
  }).then((res) => {
      res.json()
        .then((data) => {
          dispatch({
            type: 'ELEMENT_GET_POSITION_FILTER',
            payload: data.positions.filter((item) => Boolean(item))
          })
        })
    })

  fetch(`${ServerIp}api/v2/elements/get_material_types${filter}`, {
    method: 'GET',
    headers: {
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
  }).then((res) => {
      res.json()
        .then((data) => {
          dispatch({
            type: 'ELEMENT_GET_MATERIAL_TYPES_FILTER',
            payload: data.material_types.filter((item) => Boolean(item))
          })
        })
    })

  fetch(`${ServerIp}api/v2/elements/get_lines${filter}`, {
    method: 'GET',
    headers: {
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
  }).then((res) => {
      res.json()
        .then((data) => {
          dispatch({
            type: 'ELEMENT_GET_LINES_FILTER',
            payload: data.lines.filter((item) => Boolean(item))
          })
        })
    })
};

export const getDropdownFilters = (value, name, props) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const tempProps = props;

  switch(name) {
    case 'line':
      dispatch({
        type: 'SET_LINE_FILTER',
        payload: value !== 'none' ? value : '',
      });
      tempProps.line = value !== 'none' ? value : '';
      break;
    case 'position':
      dispatch({
        type: 'SET_POSITION_FILTER',
        payload: value !== 'none' ? value : '',
      });
      tempProps.position = value !== 'none' ? value : '';
      break;
    case 'material_type':
      dispatch({
        type: 'SET_MATERIAL_TYPE_FILTER',
        payload: value !== 'none' ? value : '',
      });
      tempProps.materialType = value !== 'none' ? value : '';
      break;
  }

  let filter = '?';
  props.street.forEach((item) => {
    filter += `street[]=${item}&`;
  })
  props.location.forEach((item) => {
    filter += `location[]=${item}&`;
  })
  fetch(`${ServerIp}api/v2/elements/index${filter}line=${tempProps.line || ''}&position=${encodeURIComponent(tempProps.position) || ''}&material_type=${tempProps.materialType || ''}&remarks=${tempProps.remarks || ''}&rl_min=${tempProps.rl.min || ''}&rl_max=${tempProps.rl.max || ''}&qd_min=${tempProps.qd.min || ''}&qd_max=${tempProps.qd.max || ''}&date_start=${tempProps.date.start || ''}&date_end=${tempProps.date.end || ''}&application_date_start=${tempProps.applicationDate.start || ''}&application_date_end=${tempProps.applicationDate.end || ''}`, {
    method: 'GET',
    headers: {
      Authorization: `Token token="${token}", identifier="${user}"`,
    }
  }).then((res) => {
    res.json()
      .then((data) => {
        dispatch({
          type: 'ELEMENTS_GET_SUCCESS',
          payload: data.data.map((item) => item.attributes),
        });

      })
  })
}

export const getAllElements = (props = {}) => (dispatch) => {
  dispatch({ type: 'ELEMENTS_GET_PENDING' });
  dispatch({ type: 'ELEMENTS_INIT_SAVE_FILTER', payload: props });
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  let filter = '?';
  props.street.forEach((item) => {
    filter += `street[]=${item}&`;
  })
  props.location.forEach((item) => {
    filter += `location[]=${item}&`;
  })

  fetch(`${ServerIp}api/v2/elements/index${filter}`, {
    method: 'GET',
    headers: {
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
  }).then((res) => {
    if (res.status < 400) {
      res.json()
        .then((data) => {
          dispatch({
            type: 'ELEMENTS_GET_SUCCESS',
            payload: data.data.map((item) => item.attributes),
          });
        });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to fetch elements, please refrest the page!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const getAllLocations = () => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  dispatch({ type: 'ELEMENTS_GET_PENDING' });
  fetch(`${ServerIp}/api/v1/locations/index`, {
    headers: {
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
  }).then((res) => {
    if (res.status < 400) {
      res.json()
        .then((data) => {
          dispatch({
            type: 'LOCATIONS_GET_SUCCESS',
            payload: data.locations,
          });
        });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to fetch locations, please refrest the page!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const setSingleElementID = (id) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v2/elements/measurements_retroreflection/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
  }).then((res) => {
    if (res.status === 200) {
      res.json().then((data) => {
        dispatch({
          type: 'SET_SINGLE_ELEMENT_ID',
          payload: {
            id,
            measurements: data.data.map((item) => ({
              rl: item.attributes.rl,
              qd: item.attributes.qd,
              id: item.attributes.id,
            })),
          },
        });
      });
    }
  });
};

export const fetchElementValues = async (elementId) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const res = await fetch(`${ServerIp}/api/v1/elements/show`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ element: { id: elementId } }),
  })

  if (res.status < 400) {
    return res.json();
  }

  return null;
};

export const getSingleElement = (elementId) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  dispatch({ type: 'ELEMENT_GET_PENDING' });
  fetch(`${ServerIp}/api/v1/elements/show`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ element: { id: elementId } }),
  }).then((res) => {
    if (res.status < 400) {
      res.json()
        .then((data) => {
          fetch(`${ServerIp}/api/v1/elements/statistics`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Token token="${token}", identifier="${user}"`,
            },
            body: JSON.stringify({ element: { id: elementId } }),
          }).then((resStatistics) => {
            if (resStatistics.status < 400) {
              resStatistics.json().then((dataStatistic) => {
                data.statistics = dataStatistic;
                fetch(`${ServerIp}/api/v2/element_images/${elementId}`, {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Token token="${token}", identifier="${user}"`,
                  },
                })
                  .then((resImg) => {
                    if (resImg.status < 400) {
                      resImg.json().then((dataImg) => {
                        data.images = dataImg;
                        dispatch({
                          type: 'ELEMENT_GET_SUCCESS',
                          payload: data,
                        });
                      });
                    } else {
                      dispatch({
                        type: 'GET_FAIL',
                        payload: 'Failed to fetch element, please try again!',
                      });
                      setTimeout(() => {
                        dispatch({
                          type: 'RESET_ERROR',
                        });
                      }, 50);
                    }
                  });
              });
            } else {
              dispatch({
                type: 'GET_FAIL',
                payload: 'Failed to fetch element, please try again!',
              });
              setTimeout(() => {
                dispatch({
                  type: 'RESET_ERROR',
                });
              }, 50);
            }
          });
        });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to fetch element, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export function toggleDisplayElement(element) {
  return {
    type: 'DISPLAY_ELEMENT_TOGGLE',
    payload: element.target.value,
  };
}

export function toggleDisplayMeasurement(element) {
  return {
    type: 'DISPLAY_MEASUREMENT_TOGGLE',
    payload: element.target.value,
  };
}

export function setColorFilter(arr, type) {
  return {
    type: 'CHANGE_COLOR_VALUE',
    payload: {arr, value: type},
  };
}

export const handleElementUpdate = (element) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/elements/update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({
      element: {
        air_humidity: element.air_humidity,
        SRT: element.SRT,
        air_temperature: element.air_temperature,
        coordinates: `POINT(${element.coordinates[0]} ${element.coordinates[1]})`,
        date: element.date,
        grit_beads: element.grit_beads,
        grit_type: element.grit_type,
        id: element.id,
        line: element.line,
        location: element.location,
        material_type: element.material_type,
        measurements: element.measurements,
        position: element.position,
        qd: element.qd,
        rl: element.rl,
        rw: element.rw,
        street: element.street,
        application_date: element.application_date,
        notification_date: element.notification_date,
        remarks: element.remarks,
      },
    }),
  }).then((res) => {
    if (res.status === 200) {
      res.json().then((data) => {
        dispatch({
          type: 'ELEMENT_UPDATE_SUCCESS',
          payload: data,
        });
      });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to update element, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const handleElementDelete = (id) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/elements/destroy`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ element: { ids: id } }),
  }).then((res) => {
    if (res.status === 200) {
      res.json().then((data) => {
        dispatch({
          type: 'ELEMENT_DELETE_SUCCESS',
          payload: data,
        });
      });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to delete element, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const handleElementCreate = (element) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  // TODO: -> element: { coordinates: "POINT(lat:decimal lng:decimal)" }
  fetch(`${ServerIp}/api/v1/elements/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ element: { coordinates: `POINT(${element.lat} ${element.lon})` } }),
  }).then((res) => {
    if (res.status === 200) {
      res.json().then((data) => {
        dispatch({
          type: 'ELEMENT_CREATE_SUCCESS',
          payload: data,
        });
      });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to create element, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const handledMeasurementSave = (measuremen) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/measurements/update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ measurement: measuremen }),
  }).then((res) => {
    if (res.status < 400) {
      res.json()
        .then((data) => {
          dispatch({
            type: 'MEASUREMENT_UPDATE_SUCCESS',
            payload: { data },
          });
        });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to update measurement, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const handledMeasurementAdd = (element, id) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/measurements/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ measurement: { ...element, element_id: id } }),
  }).then((res) => {
    if (res.status < 400) {
      res.json()
        .then((data) => {
          dispatch({
            type: 'MEASUREMENT_CREATE_SUCCESS',
            payload: data,
          });
        });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to create measurement, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const handledMeasurementDelete = (arr) => (dispatch) => {
  if (!arr.length) {
    return null;
  }
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/measurement_collections/destroy`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ measurements_array: { measurement_ids: arr } }),
  }).then((res) => {
    if (res.status < 400) {
      res.json()
        .then(() => {
          dispatch({
            type: 'MEASUREMENT_DELETED_SUCCESS',
            payload: arr,
          });
        });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to delete measurement, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const searchElements = (search) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/elements_filters/show`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ filters: { search } }),
  }).then((res) => {
    if (res.status < 400) {
      res.json()
        .then((data) => {
          dispatch({
            type: 'FILTER_ELEMENTS_SUCCESS',
            payload: data,
          });
        });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: `Failed to search elements by ${search}, please try again!`,
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const showMesurements = (arr) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  const cords = `LINESTRING(${arr[0].lat} ${arr[0].lng}, ${arr[1].lat} ${arr[1].lng}, ${arr[2].lat} ${arr[2].lng}, ${arr[3].lat} ${arr[3].lng}, ${arr[0].lat} ${arr[0].lng})`;
  fetch(`${ServerIp}/api/v1/measurements_from_polygon/index`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ polygon_measurements: { polygon: cords } }),
  }).then((res) => {
    if (res.status < 400) {
      res.json()
        .then((data) => {
          dispatch({
            type: 'MEASUREMENT_FETCH_SUCCESS',
            payload: data.map && data.map.length ? data.map((item) => ({
              id: item.id,
              coordinates: item.coordinates,
              rl: item.rl,
              qd: item.qd,
            })) : [],
          });
        });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to fetch measurements, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const mergeMesurements = (id, arr) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  const cords = `LINESTRING(${arr[0].lat} ${arr[0].lng}, ${arr[1].lat} ${arr[1].lng}, ${arr[2].lat} ${arr[2].lng}, ${arr[3].lat} ${arr[3].lng}, ${arr[0].lat} ${arr[0].lng})`;
  fetch(`${ServerIp}/api/v1/element_editor/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ element: { element_id: id, polygon: cords } }),
  }).then((res) => {
    if (res.status < 400) {
      fetch(`${ServerIp}/api/v1/elements/index`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token token="${token}", identifier="${user}"`,
        },
      }).then((res) => {
        if (res.status < 400) {
          res.json()
            .then((data) => {
              dispatch({
                type: 'ELEMENTS_GET_SUCCESS',
                payload: data,
              });
            });
        } else {
          dispatch({
            type: 'GET_FAIL',
            payload: 'Failed to merge elements, please refrest the page!',
          });
          setTimeout(() => {
            dispatch({
              type: 'RESET_ERROR',
            });
          }, 50);
        }
      });

      Alert.success('Merge success', {timeout: 2000});
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to merge measurements, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export function unselectSelectedElement() {
  return {
    type: 'UNSELECT_ELEMENT',
  };
}

export const handleManualMeasurementsCreate = (id, arr) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/measurements_to_element/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ element: { element_id: id, measurement_ids: arr } }),
  }).then((res) => {
    if (res.status === 200) {
      res.json().then((data) => {
        dispatch({
          type: 'ELEMENT_GET_SUCCESS',
          payload: data,
        });
      });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to merge, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export function statisticFilterCreate(items) {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v1/report/elements_status_report`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ report: items }),
  }).then((res) => {
    if (res.status === 200) {
      res.blob().then((data) => {
        download(data, `${new Date()}.xlsx`.replace(/ /g, '_'));
      });
    } else {
      Alert.error('Generate report failed', {timeout: 2000});
    }
  });
}

export const filterElements = (values, name, props) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const tempProps = props;

  switch(name) {
    case 'Remarks':
      dispatch({
        type: 'SET_REMARKS_FILTER',
        payload: values.value,
      });
      tempProps.remarks = values.value;
      break;
    case 'RL':
      dispatch({
        type: 'SET_RL_FILTER',
        payload: values,
      });
      tempProps.rl = values;
      break;
    case 'Qd':
      dispatch({
        type: 'SET_QD_FILTER',
        payload: values,
      });
      tempProps.qd = values;
      break;
    case 'date':
      dispatch({
        type: 'SET_DATE_FILTER',
        payload: {start: values.min, end: values.max},
      });
      tempProps.date = {start: values.min, end: values.max};
      break;
    case 'application_date':
      dispatch({
        type: 'SET_APPLICATION_DATE_FILTER',
        payload: {start: values.min, end: values.max},
      });
      tempProps.applicationDate = {start: values.min, end: values.max};
      break;
  }

  let filter = '?';
  props.street.forEach((item) => {
    filter += `street[]=${item}&`;
  })
  props.location.forEach((item) => {
    filter += `location[]=${item}&`;
  })

  fetch(`${ServerIp}api/v2/elements/index${filter}line=${tempProps.line || ''}&position=${encodeURIComponent(tempProps.position) || ''}&material_type=${tempProps.materialType || ''}&remarks=${tempProps.remarks || ''}&rl_min=${tempProps.rl.min || ''}&rl_max=${tempProps.rl.max || ''}&qd_min=${tempProps.qd.min || ''}&qd_max=${tempProps.qd.max || ''}&date_start=${tempProps.date.start || ''}&date_end=${tempProps.date.end || ''}&application_date_start=${tempProps.applicationDate.start || ''}&application_date_end=${tempProps.applicationDate.end || ''}`, {
    method: 'GET',
    headers: {
      Authorization: `Token token="${token}", identifier="${user}"`,
    }
  }).then((res) => {
    res.json()
      .then((data) => {
        dispatch({
          type: 'ELEMENTS_GET_SUCCESS',
          payload: data.data.map((item) => item.attributes),
        });
      })
  })
};

export const initialFetchAll = (props) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  let filter = '?';
  props.street.forEach((item) => {
    filter += `street[]=${item}&`;
  })
  props.location.forEach((item) => {
    filter += `location[]=${item}&`;
  })

  fetch(`${ServerIp}api/v2/elements/index${filter}line=${props.line || ''}&position=${encodeURIComponent(props.position) || ''}&material_type=${props.materialType || ''}&remarks=${props.remarks || ''}&rl_min=${props.rl.min || ''}&rl_max=${props.rl.max || ''}&qd_min=${props.qd.min || ''}&qd_max=${props.qd.max || ''}&date_start=${props.date.start || ''}&date_end=${props.date.end || ''}&application_date_start=${props.applicationDate.start || ''}&application_date_end=${props.applicationDate.end || ''}`, {
    method: 'GET',
    headers: {
      Authorization: `Token token="${token}", identifier="${user}"`,
    }
  }).then((res) => {
    res.json()
      .then((data) => {
        dispatch({
          type: 'ELEMENTS_GET_SUCCESS',
          payload: data.data.map((item) => item.attributes),
        });
      })
  })
}

export function clearFilters(props) {
  return {
    type: 'CLEAR_FILTERS',
    payload: props
  };
}



// WEBPACK FOOTER //
// ./src/actions/elements.js